import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#626C9D",
      d: "M10.734 18.266A1.037 1.037 0 1 1 9.266 16.8l4.8-4.8-4.8-4.798-.07-.08a1.038 1.038 0 0 1 1.459-1.459l.079.071 5.533 5.533a1.037 1.037 0 0 1 0 1.467z"
    }, null, -1)
  ])))
}
export default { render: render }